import {ChevronDownIcon, ChevronUpIcon, ProjectTemplateIcon, TableIcon} from '@primer/octicons-react'
import {ActionList, Text} from '@primer/react'
import {graphql, useFragment} from 'react-relay'

import {LABELS} from '../../constants'
import type {ProjectItemSectionView$key} from './__generated__/ProjectItemSectionView.graphql'

export type ProjectItemSectionViewProps = {
  projectItem: ProjectItemSectionView$key
  open: boolean
  setOpen: (isOpen: boolean) => void
}

export function ProjectItemSectionView({projectItem, setOpen, open}: ProjectItemSectionViewProps) {
  const {project, isArchived, fieldValueByName} = useFragment(
    graphql`
      fragment ProjectItemSectionView on ProjectV2Item {
        isArchived
        project {
          title
          template
          viewerCanUpdate
        }
        fieldValueByName(name: "Status") {
          ... on ProjectV2ItemFieldSingleSelectValue {
            name
          }
        }
      }
    `,
    projectItem,
  )

  return (
    <ActionList.Item onSelect={() => setOpen(!open)}>
      <ActionList.LeadingVisual>{project.template ? <ProjectTemplateIcon /> : <TableIcon />}</ActionList.LeadingVisual>

      {project.title}
      {!open && (
        <ActionList.Description variant="block">
          <Text sx={{color: project.viewerCanUpdate ? 'fg.default' : 'fg.subtle'}}>
            {isArchived ? LABELS.archived : fieldValueByName?.name || LABELS.emptySections.status}
          </Text>
        </ActionList.Description>
      )}

      <ActionList.TrailingVisual>{!open ? <ChevronDownIcon /> : <ChevronUpIcon />}</ActionList.TrailingVisual>
    </ActionList.Item>
  )
}

try{ ProjectItemSectionView.displayName ||= 'ProjectItemSectionView' } catch {}